<mat-icon
  class="field-help-icon"
  [matTooltip]="tooltipText"
  matTooltipPosition="right"
  matTooltipClass="field-help-tooltip">
  help_outline
</mat-icon>
